import React, { FC, useMemo } from 'react';

import DataGrid, { Column, GroupPanel, Pager, Paging } from 'devextreme-react/data-grid';

import moment from 'moment';

import { Button } from 'devextreme-react';

import { useTestSignalRMutation } from 'bus/signalR/services';

import $createStore from '../../utils/create-store-instance';

const TestPage: FC = () => {
  const shiftDateSource: any = useMemo(() => $createStore('/v1/Shift/4', 'id'), []);

  const [testSignalR] = useTestSignalRMutation();

  const testSignalRTest = () => {
    testSignalR();
  };

  return (
    <div>
      <Button className="send mr-2 mb-3" onClick={testSignalRTest} text="test signalR" />
      <DataGrid
        dataSource={shiftDateSource}
        showBorders={false}
        loadPanel={{
          enabled: true,
          text: 'Загрузка',
        }}
        remoteOperations={true}
      >
        <GroupPanel visible={true} />
        <Column
          dataField="requestId"
          caption="requestId"
          groupIndex={0}
          groupCellTemplate={(elem: any, data: any) => {
            var formattedValue = `<div>Время: ${moment(data.data.items[0].date).format(
              'HH:mm',
            )};</di> <div>Контрагент: ${data.data.items[0].contractor}; </div><div> Марка:  ${
              data.data.items[0].nomenclature
            }</div>`;
            //elem.append(formattedValue);
            elem.innerHTML = formattedValue;
          }}
        />
        {/* <Column dataField="date" caption="date"  /> */}
        {/* <Column dataField="contractor" caption="contractor"  /> */}
        {/* <Column dataField="nomenclature" caption="nomenclature"  /> */}
        <Column dataField="transport" caption="transport" />
        <Column dataField="driver" caption="driver" />
        <Column dataField="fault" caption="fault" />
        <Column dataField="quantity" caption="quantity" />

        {/* <Export enabled={true} allowExportSelectedData={true} /> */}
        <Paging defaultPageSize={100} />
        <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
      </DataGrid>
    </div>
  );
};

export default TestPage;
